import { parseKanunMaddesi } from './kanunMaddeParse';

// Tek bir kanun-madde metnini kanonik forma çevirir (ör. "5237 m. 50/1-a" -> "TCK m. 50/1-a").
// Parse edilemiyorsa (madde numarası/kanun yok) ÇÖP üretmez; orijinali kırpıp döndürür.
export function normalizeKanunMaddesi(madde) {
  const p = parseKanunMaddesi(madde);
  if (p.parsed) return p.canonical;
  if (typeof madde === 'string') return madde.trim();
  return p.raw || '';
}

export function normalizeKanunMaddeleri(maddeler) {
  return [...new Set((maddeler || []).map(normalizeKanunMaddesi).filter(Boolean))];
}

// Birden çok listeyi normalize edip kanonik forma göre tekilleştirir.
// "TCK m. 58" ile "5237 sayılı kanun m. 58" çiftini önler. String/obje girişini kabul eder.
export function birlestirVeNormalizeKanunMaddeleri(...listeler) {
  const map = new Map();
  listeler.flat().forEach((m) => {
    const ham = typeof m === 'string' ? m : (m && (m.value != null ? m.value : m.label)) || '';
    if (!ham) return;
    const n = normalizeKanunMaddesi(ham) || ham;
    if (n && !map.has(n)) map.set(n, n);
  });
  return [...map.values()];
}
